import { useSubjectMember } from '@healthblocks-io/core'
import { t } from '@lingui/macro'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { Flex, FlexRow } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { H1 } from '@/@bothrs-ui/web/components/typography/Heading'
import { useLayout } from '@/layout/providers/LayoutProvider'
import { mixpanel } from '@/mixpanel'
import { CareQuestionDesktopActionButton } from '@/modules/care-question/components/care-question-action-button/dekstop/CareQuestionDesktopActionButton'
import { MessageIndicator } from '@/modules/task/components/message-indicator/MessageIndicator'
import { getRouteMeta } from '@/router-meta'
import { StContainer } from './WebHeader.styled'

import type { WebHeaderProps } from './WebHeader.types'

const WebHeader = ({ showAction = true }: WebHeaderProps) => {
  // Hooks
  // ------------------------------------------------------------------------- /
  const theme = useTheme()
  const location = useLocation()
  const subjectMember = useSubjectMember()
  const title = getRouteMeta(location.pathname, subjectMember?.givenName)
  const navigate = useNavigate()

  const { isWebHeaderVisible } = useLayout()

  // Interaction Methods
  // ------------------------------------------------------------------------- /
  function handleAppointmentClick() {
    mixpanel.track('appointment_booking_start', {
      origin: 'header',
    })
    navigate('/appointment')
  }

  // Render
  // ------------------------------------------------------------------------- /

  if (!isWebHeaderVisible) {
    return null
  }

  return (
    <StContainer>
      <FlexRow justifyContent='space-between' alignItems='center'>
        <H1 noMargin data-test-id='web-header-title'>
          {title?.title}
        </H1>
        {showAction ? (
          <Flex alignItems='center' gap={theme.UI.Spacing.Space8}>
            <Flex alignItems='center' gap={theme.UI.Spacing.Space4}>
              {/* APPOINTMENT CTA */}
              <Button
                variant='Primary'
                prefixIcon={['fal', 'calendar-plus']}
                inline
                onClick={() => {
                  mixpanel.track(`${location.pathname.split('/')[1]}_book_appointment`)
                  handleAppointmentClick()
                }}
                data-test-id='home-book-appointment'
              >
                {t({
                  id: 'globals.header-action.create-appointment',
                  comment: 'Header action to create a new appointment on the web version',
                  message: 'Maak een nieuwe afspraak',
                })}
              </Button>
              {/* CAREQUESTION CTA */}
              <CareQuestionDesktopActionButton
                title={t({
                  id: 'web-header.care-question-cta.title',
                  message: 'Meer',
                })}
              />
            </Flex>

            <MessageIndicator />
          </Flex>
        ) : null}
      </FlexRow>
    </StContainer>
  )
}

export { WebHeader }
